import React, { useEffect, useState } from 'react';
import { StyleSheet, TouchableWithoutFeedback, View } from 'react-native';
import { rem } from 'design-system';
import IconRadio from 'design-system/icons/IconRadio';
import Text from 'design-system/Text';
const RadioForm = ({ onPress, options, initial }) => {
    const [selected, setSelected] = useState(initial);
    useEffect(() => {
        onPress(selected);
    }, [onPress, selected]);
    return (<>
      {options.map(({ label, value }, index) => (<TouchableWithoutFeedback key={value.toString()} onPress={() => {
                setSelected(index);
            }}>
          <View style={styles.optionContainer}>
            <Text Text-16>{label}</Text>
            <IconRadio selected={selected === index}/>
          </View>
        </TouchableWithoutFeedback>))}
    </>);
};
const styles = StyleSheet.create({
    optionContainer: {
        padding: rem(16),
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
});
export default RadioForm;
